import { array, intersect, partial, string, struct } from 'io-ts/Decoder';

import { Area } from '../../../ui/geometry/Area';

export const Request = intersect(
	struct({
		text: string,
	})
)(
	partial({
		areas: array(Area),
	})
);
